<template>
  <section>
    <div class="painel">
      <div class="fechamentos">
        <div class="cabecalho-fechamentos">
          <a href='javascript:void(0)'>
            <div class="h2 mb-0 icon-detalhe-fechamentoextra">
              <router-link to="/ExibirFechamentoExtra"><b-icon-arrow-left-short></b-icon-arrow-left-short></router-link>
            </div>
          </a>
          <h2>Fechamento extracontratual n° {{fechamentoAtual.id}}</h2>
        </div>
        <table id="tabelaControle" class="table table-borderless">
          <tbody>
            <tr>
              <th>
                <h4 class="sub-header">Dados do Fechamento</h4>
              </th>
            </tr>
            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Estado:</strong>
                </div>
              </td>
              <td nowrap class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{fechamentoAtual.uf}}
                </div>
              </td>
            </tr>
            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Contrato:</strong>
                </div>
              </td>
              <td nowrap class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{fechamentoAtual.tipo_imovel_servico}}
                </div>
              </td>
            </tr>
            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Mês de referência:</strong>
                </div>
              </td>
              <td nowrap class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{fechamentoAtual.nome}}
                </div>
              </td>
            </tr>
            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Ano de referência:</strong>
                </div>
              </td>
              <td nowrap class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{fechamentoAtual.ano_de_referencia}}
                </div>
              </td>
            </tr>

            <!-- OI DETALHES -->
            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Valor Oi:</strong>
                </div>
              </td>
              <td  v-if="fechamentoAtual.valor_extra > 0" class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{ moeda(fechamentoAtual.valor_extra) }}
                </div>
              </td>
              <td v-else class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <span class="downloadArquivo"> - </span>
                </div>
              </td>
            </tr>

            <tr v-if="fechamentoAtual.siglas_extra">
              <td nowrap class="col-md-12" colspan="2">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <strong>Detalhamento Oi:</strong>
                </div>
                <div v-if="fechamentoAtual.siglas_extra != ''" class="col-sm-12 col-md-12 col-lg-12">
                  <table class="table table-borderless table-hover table-sm table-responsive w-100">
                    <thead>
                      <tr>
                        <th>Número do chamado</th>
                        <th>Sigla</th>
                        <th>Valor</th>
                        <th>Serviço</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="extra in fechamentoAtual.siglas_extra" :key="extra.id">
                        <td nowrap>{{extra.numero_chamado}}</td>
                        <td nowrap>{{extra.sigla}}</td>
                        <td nowrap>{{ moeda(extra.valor) }}</td>
                        <td>{{extra.servico}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="col-sm-12 col-md-12 col-lg-12"> - </div>
              </td>
            </tr>
            <tr v-else>
              <!-- <td nowrap class="col-md-3" v-if="fechamentoAtual.predio_id && fechamentoAtual.valor_extra *1 > 0"> -->
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Siglas Oi:</strong>
                </div>
              </td>
              <td v-if="fechamentoAtual.predio_id ">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <div class="siglas_extra" v-for="item in predios" v-bind:key="item.sigla">
                    <b-badge pill variant="light" class='bdg'>{{ item.sigla }}</b-badge>
                  </div>
                </div>
              </td>
              <td v-else>
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <span> - </span>
                </div>
              </td>
            </tr>

            <tr>
              <td nowrap>
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Arquivo Carga Extra (Oi):</strong>
                </div>
              </td>
              <td v-if="fechamentoAtual.arquivo_carga_extra && fechamentoAtual.arquivo_carga_extra !== ' -- '">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <a class="downloadArquivo" href="javascript:void(0)" v-on:click="downloadArquivo(fechamentoAtual.arquivo_carga_extra)">Download</a>
                </div>
              </td>
              <td v-else>
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <span class="downloadArquivo"> - </span>
                </div>
              </td>
            </tr>            

            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Arquivo Extracontratual Oi:</strong>
                </div>
              </td>
              <td v-if="fechamentoAtual.arquivo_extra && fechamentoAtual.arquivo_extra !== ' -- '" class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <a class="downloadArquivo" href="javascript:void(0)" v-on:click="downloadArquivo(fechamentoAtual.arquivo_extra)">Download</a>
                </div>
              </td>
              <td v-else class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <span class="downloadArquivo"> - </span>
                </div>
              </td>
            </tr>

            <!-- COMODATO DETALHES -->
            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Valor Comodato:</strong>
                </div>
              </td>
              <td v-if="fechamentoAtual.comodato_extra > 0" class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{ moeda(fechamentoAtual.comodato_extra) }}
                </div>
              </td>
              <td v-else class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <span class="downloadArquivo"> - </span>
                </div>
              </td>
            </tr>

            <tr v-if="fechamentoAtual.siglas_comodato_extra">
              <td nowrap class="col-md-12" colspan="2">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <strong>Detalhamento Comodato:</strong>
                </div>
                <div v-if="fechamentoAtual.siglas_comodato_extra != ''" class="col-sm-12 col-md-12 col-lg-12">
                  <table class="table table-borderless table-hover table-sm table-responsive w-100">
                    <thead>
                      <tr>
                        <th>Número do chamado</th>
                        <th>Sigla</th>
                        <th>Valor</th>
                        <th>Serviço</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="comodato in fechamentoAtual.siglas_comodato_extra" :key="comodato.id">
                        <td nowrap>{{comodato.numero_chamado}}</td>
                        <td nowrap>{{comodato.sigla}}</td>
                        <td nowrap>{{ moeda(comodato.valor) }}</td>
                        <td>{{comodato.servico}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="col-sm-12 col-md-12 col-lg-12"> - </div>
              </td>
            </tr>
            <tr v-else>
              <!-- <td nowrap class="col-md-3" v-if="fechamentoAtual.predio_id && fechamentoAtual.comodato_extra *1 > 0"> -->
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Siglas Comodato:</strong>
                </div>
              </td>
              <td v-if="fechamentoAtual.predio_id ">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <div class="siglas_extra" v-for="item in predios" v-bind:key="item.sigla">
                    <b-badge pill variant="light" class='bdg'>{{ item.sigla }}</b-badge>
                  </div>
                </div>
              </td>
              <td v-else>
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <span> - </span>
                </div>
              </td>
            </tr>

            <tr>
              <td nowrap>
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Arquivo Carga Comodato:</strong>
                </div>
              </td>
              <td v-if="fechamentoAtual.arquivo_carga_comodato && fechamentoAtual.arquivo_carga_comodato !== ' -- '">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <a class="downloadArquivo" href="javascript:void(0)" v-on:click="downloadArquivo(fechamentoAtual.arquivo_carga_comodato)">Download</a>
                </div>
              </td>
              <td v-else>
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <span class="downloadArquivo"> - </span>
                </div>
              </td>
            </tr>

            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Arquivo Extracontratual Comodato:</strong>
                </div>
              </td>
              <td v-if="fechamentoAtual.arquivo_comodato && fechamentoAtual.arquivo_comodato !== ' -- '" class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <a class="downloadArquivo" href="javascript:void(0)" v-on:click="downloadArquivo(fechamentoAtual.arquivo_comodato)">Download</a>
                </div>
              </td>
              <td v-else class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <span class="downloadArquivo"> - </span>
                </div>
              </td>
            </tr>            

            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Data preenchimento:</strong>
                </div>
              </td>
              <td nowrap class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{fechamentoAtual.data_envio_fechamento }}
                </div>
              </td>
            </tr>            
            <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Email de quem preencheu:</strong>
                </div>
              </td>
              <td nowrap class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{ fechamentoAtual.email }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Descrição:</strong>
                </div>
              </td>
              <td class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  {{fechamentoAtual.descricao_extra}}
                </div>
              </td>
            </tr>
            <!-- <tr>
              <td nowrap class="col-md-3">
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <strong>Tipos de serviço:</strong>
                </div>
              </td>
              <td class="col-md-9">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <div v-if="fechamentoAtual.servicos && fechamentoAtual.servicos.length > 0">
                    <span
                      v-for="servico in fechamentoAtual.servicos"
                      :key="servico.id"
                      class="badge-servico"
                    >{{ servico.descricao }}</span>
                  </div>
                  <span v-else> - </span>
                </div>
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>
      <input type="hidden" :value="fechamentoAtual">
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      fechamentoAtual: [],
      predios: [],
      controlerLoadingDownload: true,
      env: process.env
    }
  },
  mounted: function () {
    this.getFechamentoAtual()
  },
  computed: {
    fechamentoExtra: function () {
      let fechamentoId = this.$route.query.id
      let vm = this
      this.$store.commit('setFechamentoAtual', '')
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getfechamentoatual/${fechamentoId}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.fechamentoAtual = response.data
        vm.$store.commit('setFechamentoAtual', response.data)
      })
      this.getFechamentoAtual()
      return fechamentoExtra
    }
  },
  methods: {
    moeda (valor) {
      valor = valor.replace(',', '')
      valor = valor.replace('.', ',')
      valor = 'R$ ' + valor
      return valor
    },
    getFechamentoAtual () {
      let todosOsPredios = ''
      let fechamentoId = this.$route.query.id
      let vm = this
      this.$store.commit('setFechamentoAtual', '')
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getfechamentoatual/${fechamentoId}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.fechamentoAtual = response.data
        todosOsPredios = JSON.parse(JSON.parse(vm.fechamentoAtual.predio_id))
        if (todosOsPredios) {
          todosOsPredios.forEach(element => {
            vm.predios.push(element)
          })
        }
        vm.$store.commit('setFechamentoAtual', response.data)
      })
    },
    downloadArquivo: function (nomeArquivo) {
      let vm = this
      let dirBucket = 'extra_contratual'
      this.controlerLoadingDownload = false
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/downloadarquivofechamentoextra/${dirBucket}/${nomeArquivo}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.controlerLoadingDownload = true
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', {msg: response.data.mensagem, status: false, show: true})
          return
        }
        window.open(response.data.url, '_blank')
      })
    }
  }
}
</script>

<style scoped>
.siglas_extra span {
  min-width: 100px;
  display: inline-block;
}

.badge-servico {
  display: inline-block;
  background-color: #3c8dbc;
  color: #fff;
  border-radius: 4px;
  padding: 3px 10px;
  margin: 2px 4px 2px 0;
  font-size: 0.88em;
}
.bdg {
  margin: 2px;
}
.icon-detalhe-preventiva {
  font-size: 2em;
  background-color: #cccccc80;
  display: inline;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  transition: 1s;
}
.icon-detalhe-preventiva:hover {
  background-color: #00800085;
  color: #FFF;
}
.cabecalho-preventiva {
    display: flex;
    align-items: center;
    max-width: 45em;
    padding: 10px;
}
.cabecalho-preventiva h2 {
  margin: 0 0 0 1em;
}
h1 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.status-preventiva {
  background-color: #337ab747;
  color: #272626;
}
table td {
  max-width: 68%;
}
.downloadArquivo{
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// DetalhesFechamentoExtra.vue?282d32e0